import React from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';
import { EProductPriority } from 'constants/enums';
import { TagSelector } from 'views/Offers/components/TagSelector';
import { ProductsTable } from 'views/Offers/components/ProductsTable';
import AutoCompleteInput from 'components/AutoCompleteInput/AutoCompleteInput';
import BarPointsForm from 'components/BarPointsForm/BarPointsForm';
import Button from 'components/Button/Button';
import Input from 'components/Input/Input';
import InputSelectDropdown from 'components/InputSelectDropdown/InputSelectDropdown';
import RichText from 'components/RichText/RichText';

import { PRODUCT_PRIORITY_OPTIONS } from 'views/Offers/Offer.consts';

interface IProductsSectionProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  values: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setFieldValue: (field: string, value: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  currentProduct: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getProductsOptions: any[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectedProduct: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setCurrentProduct: (product: any) => void;
  addProduct: () => void;
  handleQuantityChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handlePriorityChange: (value: string) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  products: any[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  editProduct: (product: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  removeProduct: (product: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleProductReorder: (products: any[]) => void;
  hasFeatureFlagTags: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  progressBarFormValues: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleProgressBarFormChange: (...args: any[]) => void;
}

export const ProductsSection: React.FC<IProductsSectionProps> = ({
  values,
  setFieldValue,
  currentProduct,
  getProductsOptions,
  selectedProduct,
  setCurrentProduct,
  addProduct,
  handleQuantityChange,
  handlePriorityChange,
  products,
  editProduct,
  removeProduct,
  handleProductReorder,
  hasFeatureFlagTags,
  progressBarFormValues,
  handleProgressBarFormChange
}): React.ReactElement => {
  return (
    <>
      <RichText
        className="mb-5"
        title="Progress Bar"
        description="Track and update progress for your products"
      />
      <BarPointsForm
        initialValues={{
          progressBarId: progressBarFormValues.progressBarId,
          progressBarPoints: progressBarFormValues.progressBarPoints
        }}
        onChange={handleProgressBarFormChange}
      />
      <div className="my-9 bg-base-border h-px" />
      <RichText
        className="mb-5"
        title="Products"
        description="Add products to your offer"
      />
      <div className="flex flex-col gap-5">
        <div className="grid grid-cols-3 gap-5">
          <AutoCompleteInput
            label="Product name"
            options={getProductsOptions}
            placeholder="Search product"
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onChange={(newValue: any) => {
              setCurrentProduct({
                ...currentProduct,
                productId: newValue?.value || '',
                quantity: currentProduct?.quantity || 0,
                priority:
                  currentProduct?.priority || EProductPriority.SUB,
                publisherProductId:
                  currentProduct?.publisherProductId || ''
              });
            }}
            currentOption={selectedProduct}
            dataTestId="dashBundleProductList"
            className="truncate"
          />
          <InputSelectDropdown
            label="Products Type"
            placeholder="Select Priority"
            options={PRODUCT_PRIORITY_OPTIONS}
            listDataTestId="bundleMainSubInpt"
            defaultSelected={{
              value: currentProduct?.priority || EProductPriority.SUB,
              label: currentProduct?.priority || EProductPriority.SUB
            }}
            onOptionChange={handlePriorityChange}
          />
          <Input
            label="Quantity"
            name="quantity"
            value={currentProduct?.quantity || ''}
            type="number"
            min={0}
            onChange={handleQuantityChange}
          />
        </div>
        <Button
          variant="secondary"
          disabled={
            !currentProduct?.productId || !currentProduct?.quantity
          }
          onClick={addProduct}
          leftIcon={
            <FontAwesomeIcon
              icon="fa-regular fa-circle-plus"
              className="w-5 h-5"
            />
          }
          className="w-full"
          dataTestId="bundleAddProductBtn"
        >
          Add Product
        </Button>
        <ProductsTable
          products={products}
          onEdit={editProduct}
          onDelete={removeProduct}
          onReorder={handleProductReorder}
        />
      </div>
      {hasFeatureFlagTags && (
        <TagSelector
          tags={values.tags}
          onTagsChange={(newTags) => setFieldValue('tags', newTags)}
        />
      )}
    </>
  );
};
